<template>
  <div :class="classObj" class="app-wrapper">
    <div
      v-if="device === 'mobile' && sidebar.opened"
      class="drawer-bg"
      @click="handleClickOutside"
    />
    <sidebar class="sidebar-container"/>
    <div class="main-container">
      <div
        v-if="device === 'mobile' && !sidebar.opened"
        class="mobile-open-btn"
        @click="toggleSideBar"
      >
        <i class="el-icon-s-unfold"></i>
      </div>
      <app-main/>
    </div>
  </div>
</template>

<script>
import {AppMain, Sidebar} from "./components";
import ResizeMixin from "./mixin/ResizeHandler";
import {mapState} from "vuex";

export default {
  name: "Layout",
  components: {
    AppMain,
    Sidebar,
  },
  mixins: [ResizeMixin],
  computed: {
    ...mapState({
      sidebar: (state) => state.app.sidebar,
      device: (state) => state.app.device,
      layout: (state) => state.sys.layout,
    }),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === "mobile",
      };
    },
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch("app/closeSideBar", {withoutAnimation: false});
    },
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.mobile-open-btn {
  position: fixed;
  top: calc(10px + env(safe-area-inset-top));
  left: 10px;
  z-index: 1000;
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: #0F1C2E;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(15, 28, 46, 0.25);
  cursor: pointer;

  i {
    font-size: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/admin/layout/index.vue